const defaultAlwaysOnSchedule = () => {
  return {
    days_week: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
    time: ["06:00", "23:59"],
  };
};

export { defaultAlwaysOnSchedule };
